var htmlEntities = {
  nbsp: " ",
  cent: "\xA2",
  pound: "\xA3",
  yen: "\xA5",
  euro: "\u20AC",
  copy: "\xA9",
  reg: "\xAE",
  lt: "<",
  gt: ">",
  quot: '"',
  amp: "&",
  apos: "'"
};
module.exports = htmlEntities;
